import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import '../../../assets/css/pages/news.css';
import useScroll from '../../../core/custom-hooks/useScroll';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useCognito from '../../../core/custom-hooks/useCognito';
import { isEmpty } from '../../../core/lib/utils';
import { NewVM } from '../../../core/models/news.model';
import { onThunkGetNewDetailCMS } from '../../../core/store/thunk-new';
import NewsDetailV2 from './newDetail-v2.component';

const NewsDetailV2Container: React.FC = () => {
  useScroll();
  const dispatch = useDispatch();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { id }: any = useParams();
  const { i18n, t } = useTranslation(['common']);
  const [newsDetails, setNewsDetails] = useState<NewVM>(new NewVM());
  const { CMSToken, CMSUrl } = useCognito();

  useEffect(() => {
    if (!isEmpty(CMSToken) && !isEmpty(CMSUrl)) {
      setNewsDetails(new NewVM());
      dispatch(
        onThunkGetNewDetailCMS(
          { wpml_language: i18n.language },
          CMSUrl || '',
          CMSToken || '',
          id,
          (data) => {
            if (data.length > 0) {
              setNewsDetails(data?.[0] || []);
            }
          },
        ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, CMSToken, CMSUrl]);

  

  return <NewsDetailV2 newsDetail={newsDetails} />;
};

export default NewsDetailV2Container;
